import { render, staticRenderFns } from "./BenefitSummary.vue?vue&type=template&id=06a7d648"
import script from "./BenefitSummary.vue?vue&type=script&lang=js"
export * from "./BenefitSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports